var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar-container"},[_c('div',{staticClass:"progress-bar-value",style:({ width: _vm.value + '%', background: _vm.color  })})])}
var staticRenderFns = []

export { render, staticRenderFns }